export class ExternalComponentsHelper {
    private readonly HIDE_HEADER_FOOTER_CLASS = 'hide-header-footer';

    public openLoginPanel(): void {
        let loginButton = document.querySelector('.sofology-login a') as HTMLElement;
        if (loginButton) {
            loginButton.click();
        }

        let focusInput = document.querySelector('.focusMe') as HTMLElement;
        if (focusInput) {
            focusInput.focus();
        }
    }

    /** Use this helper method for updating counter in the top cart element BCU-49 */
    public updateTopBasketItems(count: number): void {
        const counterElement = document
            .querySelector('.basket-indicator-count') as HTMLElement;

        function updateElement(element: HTMLElement, display: string, text: string): void {
            element.style.display = display;
            element.textContent = text;
        }

        if (count) {
            updateElement(counterElement, 'block', String(count));
        } else {
            updateElement(counterElement, 'none', '');
        }
    }

    public hideUmbracoHeaderFooter(): void {
        this.getSiteRootElement()?.classList.add(this.HIDE_HEADER_FOOTER_CLASS);
    }

    public showUmbracoHeaderFooter(): void {
        this.getSiteRootElement()?.classList.remove(this.HIDE_HEADER_FOOTER_CLASS);
    }

    public getComponentHeight(component: HTMLElement | null): number {
        return component?.clientHeight ?? 0;
    }

    private getSiteRootElement(): HTMLElement {
        return document.querySelector('#site') as HTMLElement;
    }
}

export const externalComponentsHelper = new ExternalComponentsHelper();